module.exports = __webpack_public_path__ + "static/stickermule-037f47668d244493bd297d898484a19f.png";